import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import './index.scss';
import LogoSvg from '../LogoSvg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose, faEnvelope, faHome, faUser, faCode} from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
const Sidebar = ({ navOpen, setNavOpen }) => {

const showNav = navOpen;
const setShowNav = setNavOpen;
const [spinning, setSpinning] = useState(false);

return(
    <div className ='nav-bar'>
        <Link className ='logo' to ='/' aria-label="home" onClick={() => setSpinning(true)}>
            <LogoSvg
                className={`nav-logo${spinning ? ' spin' : ''}`}
                onAnimationEnd={() => setSpinning(false)}
            />
        </Link>

        <nav className={showNav ? 'mobile-show' : ''}>
            <NavLink exact = "true" activeclassname="active" to="/"
                onClick={() => setShowNav(false)}>
                <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
            </NavLink>

            <NavLink exact = "true" activeclassname="active" className = "about-link"to="/about"
                onClick={() => setShowNav(false)}>
                <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
            </NavLink>

            <NavLink exact = "true" activeclassname="active" className = "contact-link"to="/contact"
                onClick={() => setShowNav(false)}>
                <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
            </NavLink>

            {/* <NavLink 
                exact="true" 
                activeclassname="active" 
                to="/project">
            <FontAwesomeIcon icon={faCode} color="#4d4d4e" />
            </NavLink> */}

            <NavLink
                exact="true"
                activeclassname="active"
                className="project-link"
                to="/project"
                onClick={() => setShowNav(false)}
                >
            <FontAwesomeIcon icon={faCode} color="#4d4d4e" />
            </NavLink>

       {/* or whatever icon you prefer */}

            <div className="mobile-social-links">
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/ryan-saini/">
                    <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
                </a>
                <a target="_blank" rel="noreferrer" href="https://github.com/RyanSaini">
                    <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
                </a>
            </div>

            <button className='close-icon' onClick={() => setShowNav(false)}>
                <FontAwesomeIcon icon={faClose} />
            </button>
        </nav>

        <ul>
            <li>
                <a target = "_blank" rel = 'noreferrer' href='https://www.linkedin.com/in/ryan-saini/'>
                    <FontAwesomeIcon icon= {faLinkedin} color="#4d4d4e" />
                </a>

            </li>

            <li>
                <a target = "_blank" rel = 'noreferrer' href='https://github.com/RyanSaini'>
                    <FontAwesomeIcon icon= {faGithub} color="#4d4d4e" />
                </a>

            </li>
        </ul>
        <button className='hamburger-icon' onClick={() => setShowNav(true)}>
            <FontAwesomeIcon icon={faBars} />
        </button>
    </div>
    
)
}

export default Sidebar